import { render } from "./DrawerComponent.vue?vue&type=template&id=e4cbc55c&ts=true"
import script from "./DrawerComponent.vue?vue&type=script&lang=ts"
export * from "./DrawerComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__